import {
  RetailUnitSchema,
  LotteryConfigSchema,
  LotterySchema,
  TranslationConfigSchema,
  MonthlyOccurrenceSchema,
  WeeklyOccurrenceSchema,
  SingleOccurrenceSchema,
} from '@lotta/shared/types-lottery-schemas';
import type { Static } from '@sinclair/typebox';
import { Type } from '@sinclair/typebox';
import { DateTime } from 'luxon';

export type CreateLotteryParams = Static<typeof CreateLotteryParamsSchema>;
export const CreateLotteryParamsSchema = Type.Object(
  {
    retailUnit: RetailUnitSchema.properties.id,
  },
  { additionalProperties: false, $id: 'CreateLotteryParamsSchema' }
);

/**
 * Monthly occurence schema with format minimum.
 */
const CreateMonthlyOccurenceSchema = Type.Object({
  ...MonthlyOccurrenceSchema.properties,
  startDate: Type.String({
    ...MonthlyOccurrenceSchema.properties.startDate,
    formatMinimum: DateTime.now().startOf('month').toISODate(),
  }),
});

/**
 * Wekly occurence schema with format minimum.
 */
const CreateWeeklyOccurenceSchema = Type.Object({
  ...WeeklyOccurrenceSchema.properties,
  startDate: Type.String({
    ...WeeklyOccurrenceSchema.properties.startDate,
    formatMinimum: DateTime.now().startOf('day').toISODate(),
  }),
});

/**
 * Single occurence schema with format minimum.
 */
const CreateSingleOccurenceSchema = Type.Object({
  ...SingleOccurrenceSchema.properties,
  startDate: Type.String({
    ...SingleOccurrenceSchema.properties.startDate,
    formatMinimum: DateTime.now().startOf('day').toISODate(),
  }),
});

const CreateOccurenceSchema = Type.Union(
  [CreateMonthlyOccurenceSchema, CreateWeeklyOccurenceSchema, CreateSingleOccurenceSchema],
  {
    $id: 'CreateOccurenceSchema',
  }
);

export type CreateLotteryBody = Static<typeof CreateLotteryBodySchema>;
export const CreateLotteryBodySchema = Type.Object(
  {
    lottery: Type.Object({
      ...LotteryConfigSchema.properties,
      occurrence: CreateOccurenceSchema,
    }),
    translation: TranslationConfigSchema,
  },
  { additionalProperties: false, $id: 'CreateLotteryBodySchema' }
);

export type CreateLotteryResponse = Static<typeof CreateLotteryResponseSchema>;
export const CreateLotteryResponseSchema = Type.Object(
  {
    id: LotterySchema.properties.id,
  },
  { additionalProperties: false, $id: 'CreateLotteryResponseSchema' }
);
